<template>
  <div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'token',
    mounted: async function () {
      var self = this

      localStorage.removeItem('fonestorm-token')
      localStorage.removeItem('device')
      localStorage.removeItem('DND')

      if (self.$route.query.lang) {
        switch (self.$route.query.lang) {
          case 'en':
          case 'es':
          case 'fr':
            self.$root.$i18n.locale = self.$route.query.lang
            break
          default:
            break
        }
      }

      if (self.$route.query.sound_popup && self.$route.query.sound_popup === 'no') {
        localStorage.setItem('sound-popup', 'no')
      }

      try {
        const token = self.$route.params.token
        await axios.get(`${process.env.FONESTORM_API}/devices`, { headers: { token } })
        localStorage.setItem('fonestorm-token', token) // store the token in localstorage
        self.$router.push({ name: 'Selection' })
      } catch (error) {
        localStorage.removeItem('fonestorm-token') // if the request fails, remove any possible user token if possible
        self.$router.push({ name: 'Login' })
      }
    }
  }
</script>
